
function isFilteredComponent(componentId) {
    try {
        const rules = Array.isArray(window.WCCP_FILTERING_RULES) ? window.WCCP_FILTERING_RULES : [];
        return rules.some(r => r && r.enabled && String(r.component_id) === String(componentId));
    } catch { return false; }
}
function isLazyVariationsComponent(componentId) {
    try {
        const cfg = window.WCCP_LAZY_VARIATIONS;
        if (!cfg) return false;
        if (cfg.mode === 'none') return true;
        const list = Array.isArray(cfg.components) ? cfg.components : [];
        return list.some(id => String(id) === String(componentId));
    } catch { return false; }
}
function shouldFetchVariationsFor(componentId) {
    return isFilteredComponent(componentId) || isLazyVariationsComponent(componentId);
}
function isKnownSimpleProduct(componentId, productId) {
    const comp = (STATE.data?.components || []).find(c => Number(c.id) === Number(componentId));
    const p = (comp?.products || []).find(p => Number(p.product_id) === Number(productId));
    return !!p && p.is_variable === false;
}
function getVariationCacheKey(componentId, productId, hash) {
        return `${componentId}:${productId}:${hash}`;
    }


    const VAR_CACHE = new Map();

    // POST to admin-ajax for the builder's read-only actions, retrying transient network/server failures.
    // Throws after the last attempt (and shows a notice) so callers can avoid caching the failure.
    async function wccpPost(body, attempts = 3) {
        const url = (window.cdi_door_filter_ajax && window.cdi_door_filter_ajax.ajax_url) || '/wp-admin/admin-ajax.php';
        window.WCCP_LOADING?.start(); // keep the overlay up between attempts too
        try {
            for (let i = 1; ; i++) {
                try {
                    const res = await fetch(url, {
                        method: 'POST',
                        credentials: 'same-origin',
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        body: String(body)
                    });
                    if (res.status >= 500) throw new Error(`HTTP ${res.status}`);
                    const json = await res.json();
                    hideBuilderNetworkError();
                    return json;
                } catch (e) {
                    if (i >= attempts) { showBuilderNetworkError(); throw e; }
                    await new Promise(r => setTimeout(r, 500 * i));
                }
            }
        } finally {
            window.WCCP_LOADING?.stop();
        }
    }

    function showBuilderNetworkError() {
        const root = document.getElementById('wccp-composite-root');
        if (!root || root.querySelector('.wccp-network-error')) return;
        const el = document.createElement('div');
        el.className = 'wccp-network-error';
        el.setAttribute('role', 'alert');
        el.style.cssText = 'margin:0 0 12px;padding:10px 14px;border:1px solid #e0b4b4;background:#fff6f6;color:#9f3a38;border-radius:4px;';
        el.textContent = "We couldn't load the next options. Please check your connection and select your option again.";
        root.prepend(el);
    }

    function hideBuilderNetworkError() {
        const el = document.querySelector('#wccp-composite-root .wccp-network-error');
        if (el) el.remove();
    }

    function storeVariationItems(componentId, hash, items) {
        const got = new Set();
        items.forEach(item => {
            const pid = Number(item.product_id);
            got.add(pid);
            VAR_CACHE.set(`${componentId}:${pid}:${hash}`, Array.isArray(item.variations) ? item.variations : []);

            if (item.preselected) {
                window.WCCP_PRESELECT[Number(componentId)] = {
                    product_id: pid,
                    variation_id: Number(item.preselected)
                };
            }
        });
        return got;
    }

    // Items from the filter response, keyed by the selections *other than* the component's own pick.
    const VAR_PREFILL = new Map();

    function prefillKey(componentId, productId, selections, own) {
        const others = { ...(selections || {}) };
        delete others[componentId];
        return `${componentId}:${productId}:${own}:${selectionHash(others)}`;
    }

    function prefillVariationItems(componentId, selections, items, own) {
        items.forEach(item => VAR_PREFILL.set(prefillKey(componentId, Number(item.product_id), selections, own), item));
    }

    // A prefilled item is equivalent to a fresh request only when the component's own pick is still
    // empty ('none') or is exactly this product ('picked'), and every other selection is unchanged.
    function takePrefilledItem(componentId, productId, selections) {
        const ownPick = (selections || {})[componentId];
        const own = (ownPick == null || ownPick === '') ? 'none'
            : Number(ownPick) === Number(productId) ? 'picked' : null;
        if (!own) return null;
        return VAR_PREFILL.get(prefillKey(componentId, productId, selections, own)) || null;
    }

    async function fetchVariationsBatch(componentId, productIds, selections) {
        if (!shouldFetchVariationsFor(componentId)) {
            // console.debug('[WCCP] Skip variations for', componentId);
            return;
        }
        const hash = selectionHash(selections);
        const pending = (productIds || []).filter(pid => {
            if (VAR_CACHE.has(`${componentId}:${pid}:${hash}`)) return false;
            const prefilled = takePrefilledItem(componentId, pid, selections);
            if (prefilled) storeVariationItems(componentId, hash, [prefilled]);
            return !prefilled;
        });
        // Simple products never have variations (the handler skips them), so don't pay an admin-ajax round trip for them.
        const toFetch = pending.filter(pid => !isKnownSimpleProduct(componentId, pid));
        pending.forEach(pid => { if (!toFetch.includes(pid)) VAR_CACHE.set(`${componentId}:${pid}:${hash}`, []); });
        if (!toFetch.length) return;

        const body = new URLSearchParams();
        body.set('action', 'wccp_get_variations');
        body.set('component_id', String(componentId));

        const nonce = (window.cdi_door_filter_ajax && window.cdi_door_filter_ajax.nonce) || '';
        if (nonce) body.set('door_filter_nonce', nonce);

        toFetch.forEach(pid => body.append('product_ids[]', String(pid)));
        Object.entries(selections || {}).forEach(([k, v]) => {
            body.set(`selections[${k}]`, String(v ?? ''));
        });

        let json = null;
        try {
            json = await wccpPost(body);
        } catch (e) {
            // Not cached: caching [] here left the step without variation dropdowns for good.
            return;
        }

        const got = (json?.success && Array.isArray(json.data?.items))
            ? storeVariationItems(componentId, hash, json.data.items)
            : new Set();

        toFetch.forEach(pid => {
            if (!got.has(pid)) {
                VAR_CACHE.set(`${componentId}:${pid}:${hash}`, []);
                if (window.WCCP_DEV_MODE?.debug?.variationSkip) {
                    devLog('VARIATION_FILTER_NOT_APPLIED', {
                        component_id: componentId,
                        product_id: pid,
                        reason_code: 'no_variations_for_product',
                        reason: 'Backend returned no variations for this variable product',
                        source: 'fetchVariationsBatch'
                    });
                }
            }
        });
    }

    async function ensureVariationsForStep(stepEl) {
        if (!stepEl) return;

        // Its filter request failed: the options are the unfiltered list and hidden until a retry succeeds.
        if (stepEl.querySelector('.wccp-narrow-failed')) return;

        const componentId = Number(stepEl.dataset.item_id);
        const options = qsa(selFor(CLASSES.option), stepEl);
        if (!options.length) return;

        // Only products the matched scenarios allow can be shown or picked; asking for the rest cost seconds (90 products on Double Metal frames).
        const allowed = computeAllowedByComponent().get(componentId);
        const productIds = options.map(opt => Number(opt.dataset.productId)).filter(pid => !allowed || allowed.has(pid));
        const selections = collectSelectionsFromStateOrDOM();

        await fetchVariationsBatch(componentId, productIds, selections);

        const hash = selectionHash(selections);

        //  console.log("VARIATIONs ENSURED FOR STEP", {
        //     component_id: componentId,
        //     product_ids: productIds,
        //     selection_hash: hash
        //  });

        options.forEach(opt => {
            const pid = Number(opt.dataset.productId);
            const nameWrap = qs(`.${CLASSES.nameWrap.split(' ').join('.')}`, opt) || opt;
            if (!nameWrap) return;

            const existing = nameWrap.querySelector('.wccp-variation-select');
            const cacheKey = `${componentId}:${pid}:${hash}`;

            if (!VAR_CACHE.has(cacheKey)) return;

            const variations = VAR_CACHE.get(cacheKey) || [];

            if (window.WCCP_DEV_MODE?.debug?.variationSkip) {
                devLog('VARIATION_VISIBILITY', {
                    component_id: componentId,
                    product_id: pid,
                    available_variations: variations.map(v => v.variation_id),
                    selected_variation: STATE.selectedVariants?.[componentId] ?? null,
                    reason: variations.length === 1
                    ? 'single_available'
                    : 'multiple_available',
                    source: 'ensureVariationsForStep'
                });
            }


            if (!variations.length) {
                if (existing) existing.remove();
                return;
            }

            if (existing) return;

            const select = document.createElement('select');
            select.className = 'wccp-variation-select';
            select.setAttribute('data-component-id', String(componentId));
            select.setAttribute('data-product-id', String(pid));

            const ph = document.createElement('option');
            ph.value = '';
            ph.textContent = '— Select Variation —';
            select.appendChild(ph);

            variations.forEach(v => {
                const optEl = document.createElement('option');
                optEl.value = String(Number(v.variation_id || v.id || 0));
                optEl.textContent = variationLabel(v.attributes) + (v.formatted ? ` — ${v.formatted}` : '');
                select.appendChild(optEl);
            });

            autoSelectSingleVariation(select);

            select.addEventListener('change', () => {
                const compId = Number(select.dataset.componentId);
                const productId = Number(select.dataset.productId);
                STATE.selected[compId] = productId;
                STATE.selectedVariants[compId] = select.value ? Number(select.value) : undefined;

                applyVisibilityFrom(Number(stepEl.dataset.step) - 1);
            });

            nameWrap.appendChild(select);
        });

        queueMicrotask(() => applyPreselectForComponent(stepEl));

    }